export class DateRange {
  public rangeStart?: Date;
  public rangeEnd?: Date;

  public static empty() {
    return new DateRange();
  }

}
